/**
 * Public config for the admin SPA.
 *
 * CRA inlines process.env.REACT_APP_* at build time from .env.production.
 * Docker overrides those at container start by writing /config.js
 * (window.__PLP_ENV__) from the compose environment. A non-empty runtime
 * value wins; otherwise the baked value is used.
 *
 * Access must stay static (`process.env.REACT_APP_FOO`). Dynamic
 * `process.env[key]` is not replaced in production builds.
 */

const baked = {
  REACT_APP_ENABLE_MAINTENANCE_BANNER:
    process.env.REACT_APP_ENABLE_MAINTENANCE_BANNER,
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_BASE_URL_v2: process.env.REACT_APP_BASE_URL_v2,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_NOTIFICATION_SOCKET_URL:
    process.env.REACT_APP_NOTIFICATION_SOCKET_URL,
  REACT_APP_CHAT_SOCKET_URL: process.env.REACT_APP_CHAT_SOCKET_URL,
  REACT_APP_COMMUNITY_URL: process.env.REACT_APP_COMMUNITY_URL,
  REACT_APP_COMMUNITY_SOCKET_URL: process.env.REACT_APP_COMMUNITY_SOCKET_URL,
  REACT_APP_ANAYTICS_URL: process.env.REACT_APP_ANAYTICS_URL,
  REACT_APP_ANAYTICS_URL_v2: process.env.REACT_APP_ANAYTICS_URL_v2,
  REACT_APP_N8N_WEBHOOK_URL: process.env.REACT_APP_N8N_WEBHOOK_URL,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
};

const usable = (value) => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed || trimmed === 'undefined') return '';
  return trimmed;
};

export const publicEnv = (key) =>
  usable(window.__PLP_ENV__?.[key]) || usable(baked[key]);
